export default {
    watch: {
        todayStep(val) {
            if (Math.abs(val) === this.todayListNum) {
                //全部看過，開始考試
                this.$router.replace({ name: 'today-exam' })
            } else {
                //下一個單字，發音
                let state = this.$store.state
                state.wordSound.loadUrlList()
                state.wordSound.autoPlay(state.today.todayList[0].AudioFileName)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/controller/todayStepController.js